module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CHAP-TITLE"
  }, [_vm._v("Sleepy Sheep")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("This smiley sheep is perfect as a mobile or dream catcher to help you on your way to the land of nod and sweet dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-26.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e76d838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1-13.vue
// module id = 102
// module chunks = 0